import { useRef, useCallback } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { ReportService } from "../../../services/ReportsService";
import { useCurrentAccount } from "../../../hooks/useCurrentAccount";
import { AlertService } from "../../../services/Alert";
import useModal from "../../../hooks/useModal";
import Input from "../../../components/form-controls/Input";
import Button from "../../../components/form-controls/Button";

interface ModalAddNumberProps {
    showModalLink: boolean;
    onRequestClose: (refresh: boolean) => void;
}

const AddNumberModal = ({ showModalLink, onRequestClose }: ModalAddNumberProps) => {
    const tenDigitsRegex = /^[0-9]{10}$/;
    const { t } = useTranslation();
    const { account } = useCurrentAccount();
    const modalAddNumber = useRef<HTMLDivElement>(null);

    useModal(modalAddNumber, showModalLink)
    const defaultValues = {
        number: ''
    }

    const { register, handleSubmit, reset, formState: { errors, isValid, isSubmitting } } = useForm({
        mode: 'onChange',
        defaultValues
    });

    const handleTenDigits = useCallback((e: any) => {
        if (!/[0-9]/.test(e.key) && e.key !== 'Backspace') {
            e.preventDefault();
        }
        const currentValue = e.target.value.replace(/\s+/g, '');
        if (currentValue.length >= 10 && e.key !== 'Backspace') {
            e.preventDefault();
        }
    }, []);

    const submit = async (data: any) => {
        const number = '521' + data.number;
        try {
            await ReportService.addNumber(account.id, number);
            onRequestClose(true);
            resetForm()
            AlertService.toastSuccess(t('reports.blacklist.success-msg'));
        } catch (error) {
            console.error(error);
            AlertService.toastError(t('reports.blacklist.error-msg') + error.toLowerCase());
        }
    }

    const resetForm = () => {
        onRequestClose(false);
        reset();
    };

    return (
        <div className="modal fade" ref={modalAddNumber} data-bs-backdrop="static" data-bs-keyboard="false">
            <div className="modal-dialog" role="document">
                <form onSubmit={handleSubmit(submit)}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">{t("reports.blacklist.title-model")}</h4>
                            <button title="close-modal" type="button" className="btn-close" onClick={() => resetForm()}></button>
                        </div>
                        <div className="modal-body">
                            <div className="mb-3">
                                <Input
                                    label={t('number') + ' *'}
                                    placeholder={t('reports.blacklist.input-placeholder')}
                                    onKeyDown={handleTenDigits}
                                    errors={errors?.number}
                                    {...register('number', {
                                        required: true,
                                        setValueAs: (value) => value.trim(),
                                        pattern: {
                                            value: tenDigitsRegex,
                                            message: t('reports.blacklist.error-input')
                                        }
                                    })}
                                />
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-white btn-sm" onClick={() => resetForm()}>{t("btn-cancel")}</button>
                            <Button type="submit" className="btn btn-primary btn-sm" disabled={!isValid} isLoading={isSubmitting} onClick={handleSubmit(submit)}>{t("btn-save")}</Button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default AddNumberModal
